<template>
  <div class="tron-wrapper tron-wrapper-height">
    <router-view/>

    

  </div>  
</template>

<script>

export default {
  data () {
    return {
      search: '',      
    }
  },
  computed: {
  },
  mounted () {    

  },
  watch: {

  },
  methods: {        

  }
}
</script>

<style>
.hidden-mobile {
  display: block;
}
.hidden-PC {
  display: none;
}

@media (max-width: 768px) {
  .hidden-mobile {
    display: none !important;
  }
  .hidden-PC {
    display: block !important;
  }
}

.dropdown-item strong {
  font-weight: 600;
}

.tron-font-black-level3-color {
    color: #73787b !important;
}

.tron-font-size-18px {
    font-size: 18px;
}

.tron-icon {
    fill: currentColor;
    height: 1em;
    overflow: hidden;
    vertical-align: -.15em;
    width: 1em;
}


</style>